module.exports = __webpack_public_path__ + "static/img/6.bd2b727.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/eng/6.png
// module id = CYz6
// module chunks = 0